<template>
    <o-form :title="$t('sandoz.buying_group')" :url="`/api/buying_groups/${$route.params.id}?include=wholesaler_ids,wholesaler_ids.wholesaler`" class="ortic-form-horizontal mb-4" ref="form">
        <template slot-scope="props">
            <b-row>
                <b-col>
                  <o-input :label="$t('sandoz.buying_group_code')" errorField="buying_group_code" v-model="props.item.buying_group_code"/>
                  <o-input :label="$t('sandoz.buying_group')" errorField="buying_group" v-model="props.item.buying_group"/>
                  <o-input :label="$t('sandoz.customer_external_id')" errorField="customer_external_id" v-model="props.item.customer_external_id"/>
                  <o-checkbox :label="$t('sandoz.chargeback_allowed')" v-model="props.item.chargeback_allowed"></o-checkbox>
                </b-col>

                <b-col>
                  <o-input :label="$t('sandoz.kuko_warning')" errorField="kuko_warning" v-model="props.item.kuko_warning"/>
                </b-col>
            </b-row>
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('sandoz.wholesaler')}}</th>
                  <th>{{$t('sandoz.their_id')}}</th>
                  <th>{{$t('sandoz.their_name')}}</th>
                  <th class="text-right">
                    <b-btn @click.prevent="$refs.add.show()" variant="primary">
                      <fa icon="plus"/>
                    </b-btn>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(wholesalerId, i) in props.item.wholesaler_ids" :key="wholesalerId.wholesaler_id">
                  <td>{{wholesalerId.wholesaler.wholesaler}}</td>
                  <td>{{wholesalerId.their_id}}</td>
                  <td>{{wholesalerId.their_name}}</td>
                  <td class="text-right text-nowrap">
                      <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                          <b-btn @click.prevent="props.item.wholesaler_ids.splice(i, 1)"
                                  variant="secondary">
                              <fa icon="times"/>
                          </b-btn>
                      </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-modal ref="add" :title="$t('sandoz.add_wholesaler_buying_group_id')" @ok="addWholesalerId">
              <o-value-select :label="$t('sandoz.wholesaler')" ref="wholeSalerSelector" @input-object="wholesalerSelected"
                              text-field="wholesaler" url="/api/wholesalers?sortBy=wholesaler" v-model="newWholesalerId.wholesaler_id"
                              value-field="id">
              </o-value-select>

              <o-input :errorField="'their_id'" :label="$t('sandoz.their_id')" v-model="newWholesalerId.their_id"/>
              <o-input :errorField="'their_name'" :label="$t('sandoz.their_name')" v-model="newWholesalerId.their_name"/>
            </b-modal>
        </template>
    </o-form>
</template>

<script>
import axios from 'axios'
import ticket from '../auth/ticket.vue'
export default {
  components: { ticket },
  data: () => ({
    wholesalers: [],
    newWholesalerId: {
      their_id: null,
      their_name: null,
      wholesaler_id: null,
      wholesaler: null
    }
  }),
  created() {
  },
  mounted() {
    this.loadWholesalers()
  },
  methods: {
    wholesalerSelected(data) {
      this.newWholesalerId.wholesaler = data
    },
    loadWholesalers() {
      axios.get('/api/wholesalers').then((response) => {
        this.wholesalers = response.data
      }).catch((error) => {
        console.error(error)
      })
    },
    addWholesalerId() {
      this.$refs.form.item.wholesaler_ids.push({
        wholesaler_id: this.newWholesalerId.wholesaler_id,
        their_id: this.newWholesalerId.their_id,
        their_name: this.newWholesalerId.their_name,
        wholesaler: this.newWholesalerId.wholesaler
      })
      this.newWholesalerId = {
        their_id: null,
        their_name: null,
        wholesaler_id: null,
        wholesaler: null
      }
      this.$refs.add.hide()
    }
  }
}
</script>
